/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Media_Imported_SuccessInputs */

const en_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media imported successfully`)
};

const fr_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media importe avec succes`)
};

const de_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien erfolgreich importiert`)
};

const it_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importazione del contenuto multimediale riuscita`)
};

const ru_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайлы успешно импортированы`)
};

const es_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios importados exitosamente`)
};

const zh_cn2_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体文件导入成功`)
};

const ja_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアが正常にインポートされました`)
};

const hi_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया सफलतापूर्वक आयात हो गया`)
};

const pt_pt2_player_media_imported_success = /** @type {(inputs: Player_Media_Imported_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia importada com sucesso`)
};

/**
* | output |
* | --- |
* | "Media imported successfully" |
*
* @param {Player_Media_Imported_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_media_imported_success = /** @type {((inputs?: Player_Media_Imported_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Media_Imported_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_media_imported_success(inputs)
	if (locale === "de") return de_player_media_imported_success(inputs)
	if (locale === "it") return it_player_media_imported_success(inputs)
	if (locale === "ru") return ru_player_media_imported_success(inputs)
	if (locale === "es") return es_player_media_imported_success(inputs)
	if (locale === "zh-CN") return zh_cn2_player_media_imported_success(inputs)
	if (locale === "ja") return ja_player_media_imported_success(inputs)
	if (locale === "hi") return hi_player_media_imported_success(inputs)
	if (locale === "pt-PT") return pt_pt2_player_media_imported_success(inputs)
	return en_player_media_imported_success(inputs)
});